import * as React from 'react';
import { useEditorContext } from '../editor_context';
import { MarkMenu } from './MarkMenu';
import { TextStyleMenu } from './TextStyleMenu';
import { NodeMenu } from './NodeMenu';
import { MediaMenu } from './MediaMenu';
import { TableMenu } from './TableMenu';
import { HistoryMenu } from './HistoryMenu';
import { TiptapMenubar } from './TiptapMenubar';

export const MenuBar = () => {
   const { editor } = useEditorContext();

   if (!editor) {
      return null;
   }

   return (
      <TiptapMenubar>
         <MarkMenu postSeparator />
         <TextStyleMenu postSeparator />
         <NodeMenu postSeparator />
         <MediaMenu postSeparator />
         <TableMenu postSeparator />
         <HistoryMenu />
      </TiptapMenubar>
   );
};
